import React, {PureComponent} from "react"
import styled from "styled-components"

import {Overview} from "@irati/types"
import {H3, Body} from "@irati/ui/src/Typography"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {ActivityBlockWrapper} from "../../styled/styled"
import {StyledCard} from "../../../../containers/Reporting/styled"
import ActivityItem from "../../DataItem"
import DownloadUsersExport from "../../../Users/DownloadUsersExport"

const Wrapper = styled(StyledCard)`
  margin-bottom: 30px;
`

interface Props extends InjectIntl {
  platformActivity: Overview
}

class PlatformActivityBlock extends PureComponent<Props> {
  render() {
    const {formatMessage} = this.props
    const {activated, users, activatedUsers} = this.props.platformActivity

    return (
      <Wrapper id="adminSection_industryBenchmarkLoginOverview">
        <Flex justifyContent="space-between">
          <H3 marginBottom={1}>{formatMessage({id: "admin.reporting.activityBlock.title"})}</H3>
          <DownloadUsersExport />
        </Flex>
        <Body small>{formatMessage({id: "admin.reporting.activityBlock.date"})}</Body>
        <ActivityBlockWrapper>
          <ActivityItem
            dataItem={users}
            label="admin.reporting.activityBlock.people" />
          <ActivityItem
            dataItem={activatedUsers}
            label="admin.reporting.activityBlock.activatedPeople" />
          <ActivityItem
            dataItem={activated}
            isPercentage
            bold
            label="admin.reporting.activityBlock.activationRate" />
        </ActivityBlockWrapper>
      </Wrapper>
    )
  }
}

export default injectIntl(PlatformActivityBlock)
